<app-card-common [isShowingHeading]="false" class="d-none d-md-block" *ngIf="sortedFilteredData.length > 0">
  <ul>
    <!-- <li><span class="icon-alert"></span>{{ copyTotalOutages }} <strong
      *ngIf="sortedFilteredData.length > 0">{{ totalOutages | thousands }}</strong></li> -->
    <li><span class="icon-alert"></span>{{ copyTotalAffected }} <strong
        *ngIf="sortedFilteredData.length > 0">{{ totalAffected | thousands }}</strong></li>
    <li><span class="icon-checkmark-circle"></span>{{ copyTotalServed }} <strong
        *ngIf="sortedFilteredData.length > 0">{{ totalServed | thousands }}</strong>
    </li>
    <li *ngIf="isBGEStorm">
      <span>
        <i class="fa fa-circle-thin" aria-hidden="true"></i>
        <i class="fa fa-star-o" aria-hidden="true"></i>
      </span>{{ copyTotalRestored }}
      <strong *ngIf="sortedFilteredData.length > 0">{{ totalRestored | thousands }}</strong>
    </li>
  </ul>
</app-card-common>

<div class="row">
  <div class="col-sm-5" [ngClass]="{'div-filter': opCo !== 'PECO' && opCo !== 'ACE'}">
    <div class="controls filter--control">
      <span class="icon-search"></span>
      <label for="search">filter</label>
      <input type="text" name="filter" [(ngModel)]="search" placeholder="Enter Area to Filter">
      <button class="control--close icon-cross" (click)="search = ''" (keyup.enter)="search = ''" *ngIf="search">
      </button>
    </div>
  </div>

  <div class="col-sm-3 div-dropfilter" *ngIf="isShowCountyFilter">
    <app-dropdown dropdownLabelId="normal-dropdown" dropDownListId="normal-dropdown-list"
      dropDownButtonId="normal-dropdown-button" labelText="County" [options]="filterCounties"
      [(ngModel)]="selectedCountyFilter" (ngModelChange)="setDropdownValue()">
    </app-dropdown>
  </div>
</div>

<div class="d-md-none" [ngClass]="{'div-tab': opCo === 'PECO' || opCo === 'ACE'}">
  <app-fallback-table-nav></app-fallback-table-nav>
</div>

<section class="table component">
  <div class="data-view" *ngIf="tabularData">
    <figure class="tabular-data d-flex flex-column">
      <div class="table-headers">
        <div class="table-heading-row d-flex flex-row">
          <button (click)="onToggleColumn(i)" [class]="'cel column-heading d-flex column' + i + opCo" *ngFor="let header
            of tabularData.headers; let i = index" [ngClass]="{'column-last': (i === tabularData.headers.length-1)}">
            <span class="header--copy">{{ header }}</span>
            <span class="icon chevron" [class.icon-chevron-up]="sortAscending"
              [class.icon-chevron-down]="!sortAscending"
              *ngIf="'' + sortColumn === '' + i && tabularData.headers[i] !== 'MORE'">
            </span>
          </button>
        </div>
      </div>

      <div class="table-rows">
        <div class="table-row d-flex" [class.even]="rowIndex % 2"
          *ngFor="let row of sortedFilteredData; let rowIndex = index">
          <div
            [ngClass]="(tabularData.headers[i] === 'CUSTOMERS RESTORED') ? 'cel column-data cust-restored' : 'cel column-data column' + i + opCo"
            *ngFor="let cel of row; let i = index">
            <span class="mobile-header"
              [ngClass]="(tabularData.headers[i] === 'CUSTOMERS RESTORED') ? 'cust-restored' : 'column' + i + opCo">{{ tabularData.headers[i] | titlecase }}</span>
            <span class="cel--copy"
              *ngIf="isPlainText(i)">{{ cel | formatCel: celStyle : tabularData.fields[i] }}</span>
            <span *ngIf="i === row.length-1 && opCo === 'ACE'" class="external-icon">
              <i class="fa fa-external-link" aria-hidden="true" (click)="getACEMoreInfoData(row)"></i>
            </span>
            <!--<a [href]="cel | urlOf: cel | safe : 'url'" *ngIf="isNavigable(i)">{{ cel }}</a>-->
          </div>
        </div>
      </div>

      <footer [ngStyle]="{ 'background-color': opCoColor} ">
        <div class="mobile-totals">
          <div *ngIf="sortedFilteredData.length > 0">{{ copyTotalAffected | titlecase }} {{ totalAffected | thousands }}
          </div>
          <div *ngIf="sortedFilteredData.length > 0">{{ copyTotalServed | titlecase }} {{ totalServed | thousands }}
          </div>
          <div *ngIf="sortedFilteredData.length > 0 && isBGEStorm">{{ copyTotalRestored | titlecase }}
            {{ totalRestored | thousands }}
          </div>
        </div>
        <span class="copy">{{ copyLastUpdated }} {{ tabularData.date }}. {{ copyUpdateNotice }}</span>
      </footer>
    </figure>
  </div>
</section>
<!-- <app-more-info [currentOutageInfo]="currentOutageInfo" [projectedRestCust]="projectedRestCust" [electricInfra]="electricInfra"></app-more-info> -->